import { createStore } from './createStore';

const initialState = {
  channelStatus: 'idle',
  lastEvent: null,
  eventCounts: {
    projects: 0,
    scenes: 0,
    keyframes: 0,
    videos: 0,
    audioClips: 0,
    assets: 0,
  },
};

/**
 * Track realtime connection status and light telemetry.
 * Useful for debugging WebSocket lifecycles across the app.
 */
export const useRealtimeStore = createStore('RealtimeStore', (set) => ({
  ...initialState,

  setChannelStatus: (channelStatus) => set({ channelStatus }),
  setLastEvent: (lastEvent) => set({ lastEvent }),

  bumpEventCount: (type) =>
    set((state) => ({
      eventCounts: {
        ...state.eventCounts,
        [type]: (state.eventCounts[type] ?? 0) + 1,
      },
    })),

  resetRealtime: () => set(() => initialState),
}));


